import { render } from "./SupplierGroups.vue?vue&type=template&id=1cc211a4"
import script from "./SupplierGroups.vue?vue&type=script&lang=js"
export * from "./SupplierGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__